import { Chip, Tooltip } from '@mui/material';
import ScheduleRounded from '@mui/icons-material/ScheduleRounded';
import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { depositSummary } from 'src/utils/depositSummary';
import { getQuoteById } from 'src/helper/backend_helper';

export default function DepositSentStatus({ eventId, to }: { eventId: number | string; to?: string }) {
  const history = useQuery(['deposit-delivery-status', Number(eventId)],
    () => getQuoteById(eventId),
    { enabled: Boolean(eventId), retry: false });
  const summary = depositSummary(history.data?.data?.data);
  const status = history.data?.data?.data?.depositEmailDelivery?.status;
  const label = status === 'QUEUED' ? 'Deposit Queued' : status === 'FAILED' ? 'Deposit Email Failed' : status && status !== 'ACCEPTED' ? 'Delivery Unconfirmed' : 'Deposit Sent';
  return <Tooltip describeChild title={[summary.deliveryLabel, summary.lastAcceptedLabel].filter(Boolean).join('. ')} arrow>
    <Chip component={to ? Link : 'div'} to={to} clickable={Boolean(to)}
      icon={<ScheduleRounded />} label={label} sx={{
        width: 150, height: 34, borderRadius: '8px', border: '1px solid #d5a327',
        backgroundColor: '#fff4cc', color: '#785600', fontWeight: 800,
        textDecoration: 'none', '.MuiChip-icon': { color: '#9a6b00', ml: 1 }
      }} />
  </Tooltip>;
}
